<template>
	<div>
<!-- 				<Chat></Chat>
				<Notes></Notes>

-->		
		<v-sheet flat color="transparent" class="video-room-wrapper">
			<VideoRoom class="room" :room="room" :settings="settings" @twilioObject="(room) => twilioObject = room"></VideoRoom>
			<v-navigation-drawer ref="sidebar" class="sidebar" :class="{'d-none': !sidebar}" v-model="sidebar" right>		
				<v-list dense class="sidebar-title">
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>{{sidebarTitle}}
								<v-tooltip v-if="tooltips[sidebar]">
									<template v-slot:activator="{on}">
										<v-btn icon v-on="on" small><v-icon small>mdi-information</v-icon></v-btn>
									</template>
									{{tooltips[sidebar]}}
								</v-tooltip>
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-icon>
							<v-btn small icon @click="sidebar = false"><v-icon small>mdi-close</v-icon> </v-btn>
						</v-list-item-icon>
					</v-list-item>
				</v-list>
				<v-card flat class="sidebar-content">
					<template v-if="sidebar == 'info'">
						<AppointmentInfo></AppointmentInfo>
						<!-- <AppointmentInfoClient v-if="clientAccess"></AppointmentInfoClient> -->
					</template>
					<Chat v-if="sidebar == 'chat'" :room="room"></Chat>
					<TimeStampNotes v-if="clientAccess && sidebar == 'notes'" :room="room" :twilioObject="twilioObject"></TimeStampNotes>
				</v-card>							
			</v-navigation-drawer>
		</v-sheet>
		<VideoToolbar :settings="settings" :room="room" :twilioObject="twilioObject" @toggleSidebar="toggleSidebar"></VideoToolbar>
	</div>
</template>
<style lang="less">
	.video-room-wrapper{
		min-height: 60vh;
		position: relative;
	}
	.sidebar {
		z-index: 4;
		margin-top: 10px;
		position: absolute;
		height: 97%;
		top: 0;
		overflow: hidden;
		.sidebar-title{
			position: relative;
			z-index: 5;
		}
	}

	.v-navigation-drawer__content{
		overflow: hidden !important;
	}
	.sidebar-content{
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		z-index: 4;
		padding-top: 56px;
	}

	.room{
		width: 100%
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import VideoToolbar from "./VideoToolbar"
	import VideoRoom from "./VideoRoom"
	import TimeStampNotes from "./TimeStampNotes"
	import AppointmentInfo from "./AppointmentInfo"
	// import AppointmentInfoClient from "./AppointmentInfoClient"

	import Chat from "./Chat"
	export default {
		name: "VideoWrapper", 
		props: {
			settings: {}, 
			room: {}
		},
		data: () => {
			return {
				twilioObject: false,
				sidebar: false,
				tooltips: {
					notes: "You can use this feature to take notes; timestamps aligned to the session’s recording are added automatically.",
					chat: "You can use this feature to share written messages (e.g. links to prototypes etc) with the user participant." 
				}
			}
		},
		components: {
			VideoToolbar, 
			VideoRoom,
			Chat,
			TimeStampNotes, 
			AppointmentInfo,
			// AppointmentInfoClient
		},
		computed: {
			...Vuex.mapState( {
				role: state => state.auth.view
			}),
			sidebarTitle(){
				if( this.sidebar == "chat" ){
					return "Chat"
				}
				if( this.sidebar == "notes" ){
					return "Notes"
				}
				return "Meeting Info"
			},
			clientAccess(){
				return this.role == "client" || this.role == "admin" || false
			}
		},
		methods: {
			toggleSidebar(what){
				if( this.sidebar == what ){
					this.sidebar = false
				}
				else{
					this.sidebar = what;
				}
			}
		}
		// created(){
			
		// }

	}
// </script>"